import { DefaultValidator } from '../'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const defaultTranslateKey = 'validator.validPhoneNumber'

export const validPhoneNumber = value => {
  const regex = new RegExp('((^(\\+42|\\+41){0,1})([0-9()\\s-]{9,}))|^$')

  return regex.test(String(value).trim())
}

export const validPhoneNumberTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(validPhoneNumber, localeKey || defaultTranslateKey),
)
